"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Request type enum
 */
var GatewayRequestType;
(function (GatewayRequestType) {
    // Whole client
    GatewayRequestType[GatewayRequestType["GET_CONFIGURATION"] = 1] = "GET_CONFIGURATION";
    GatewayRequestType[GatewayRequestType["GET_STATUS"] = 2] = "GET_STATUS";
    GatewayRequestType[GatewayRequestType["GET_OPERATIONS"] = 3] = "GET_OPERATIONS";
    GatewayRequestType[GatewayRequestType["GET_OPERATION_DETAIL"] = 4] = "GET_OPERATION_DETAIL";
    GatewayRequestType[GatewayRequestType["INVOKE_OPERATION"] = 5] = "INVOKE_OPERATION";
    // Services
    GatewayRequestType[GatewayRequestType["ADD_SERVICE"] = 6] = "ADD_SERVICE";
    GatewayRequestType[GatewayRequestType["UPDATE_SERVICE"] = 7] = "UPDATE_SERVICE";
    GatewayRequestType[GatewayRequestType["REMOVE_SERVICE"] = 8] = "REMOVE_SERVICE";
    GatewayRequestType[GatewayRequestType["GET_SERVICES"] = 9] = "GET_SERVICES";
    GatewayRequestType[GatewayRequestType["GET_SERVICE_TYPES"] = 10] = "GET_SERVICE_TYPES";
    GatewayRequestType[GatewayRequestType["GET_SERVICE_CONFIGURATION"] = 11] = "GET_SERVICE_CONFIGURATION";
    GatewayRequestType[GatewayRequestType["GET_SERVICE_STATUS"] = 12] = "GET_SERVICE_STATUS";
    GatewayRequestType[GatewayRequestType["GET_SERVICE_OPERATIONS"] = 13] = "GET_SERVICE_OPERATIONS";
    GatewayRequestType[GatewayRequestType["GET_SERVICE_OPERATION_DETAIL"] = 14] = "GET_SERVICE_OPERATION_DETAIL";
    GatewayRequestType[GatewayRequestType["INVOKE_SERVICE_OPERATION"] = 15] = "INVOKE_SERVICE_OPERATION";
})(GatewayRequestType = exports.GatewayRequestType || (exports.GatewayRequestType = {}));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/gateway-control/gateway-request-type.js
// module id = 37
// module chunks = 1